
    import { Component, Vue } from 'vue-property-decorator';
    import { mdiCar } from '@mdi/js';

    @Component
    export default class Header extends Vue {
        private title = document.title;
        private carLogo = mdiCar;
    }
